import React, { FC } from 'react';
import SubHeader from 'components/form/header/subheader';
import { SmallSpacer } from 'components/spacer/spacer';
import RadioGroup from 'components/form/radio/radio-group';
import RadioButton from 'components/form/radio/radio-button';
import { fillCycleFilterOptions, fillCycleFilterOptionsOrders } from 'constants/index';

interface FillCycleFilterProps {
  value: number;
  onChange: (value: number) => void;
  sidebarTaskType: string;
}

const FillCycleFilter: FC<FillCycleFilterProps> = ({ value, onChange, sidebarTaskType }) => {
  return (
    <>
      <SubHeader name="FILL CYCLE" />
      <SmallSpacer />
      <RadioGroup horizontal onChange={onChange}>
        {(sidebarTaskType === 'FC' ? fillCycleFilterOptions : fillCycleFilterOptionsOrders).map(
          ({ label, width, setting }) => (
            <RadioButton
              value={setting}
              maxItemWidth={width}
              key={`fill-cycle-radio-${label}`}
              checked={value === setting}
            >
              {label}
            </RadioButton>
          ),
        )}
      </RadioGroup>
    </>
  );
};

export default FillCycleFilter;
